module.exports = __webpack_public_path__ + "static/img/ninja-can-09.f92a3f70.png";